import React from 'react'
import Layout from 'features/layout/components/Layout'
import UserProfile from '../components/UserProfile'

const UserProfilePage = (props) => {
  return (
    <Layout>
      <UserProfile />
    </Layout>
  )
}

export default UserProfilePage
